"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductContributors = void 0;
const react_1 = __importDefault(require("react"));
const themed_text_1 = require("../themed-text");
const ProductContributors = (props) => {
    const { productContributors, byCopy } = props;
    const trimmedProductContributors = productContributors.slice(0, 3);
    const contributors = trimmedProductContributors.map((productContributor, index) => {
        const hasNext = index < trimmedProductContributors.length - 1;
        const { name, roles } = productContributor;
        return (react_1.default.createElement(themed_text_1.ThemedSpan, { font: "base", key: index, "data-cy": `product-contributor-name-${index}` },
            name,
            roles && roles.length > 0 && (react_1.default.createElement(themed_text_1.ThemedSpan, { font: "base", color: "secondary", "data-cy": `product-contributor-roles-${index}` },
                "\u00A0(",
                roles.join(', '),
                ")")),
            hasNext && ', '));
    });
    return trimmedProductContributors.length > 0 ? (react_1.default.createElement("div", { "data-cy": 'product-contributors' },
        byCopy && (react_1.default.createElement(themed_text_1.ThemedSpan, { font: "base", color: "secondary", "data-cy": 'product-contributor-by' },
            byCopy,
            "\u00A0")),
        contributors)) : (react_1.default.createElement(react_1.default.Fragment, null));
};
exports.ProductContributors = ProductContributors;
__exportStar(require("./types"), exports);
